import { IS_LOADING, SET_DATA_ITEM, SET_VALIDITY, SET_ERROR, SET_SUCCESS, SET_CAN_USE_KI_PILOT_THEORY, SET_YOUTUBE_LINK, SET_PRAXIS_OVERVIEW, SET_EXPLANATION_LOADING, SET_EXPLAIN_VOLUME, SET_EXPLAIN_PRE_EXAM_PERFORMANCE, SET_EXPLAIN_PERFORMANCE, SET_EXPLAIN_GENERAL_OVERVIEW, SET_EXPLAIN_CATEGORY, } from "@/store/PilotAi/types";
import { create, filter, findAll, findOne, update, getOne, resetSave } from "@/store/Crud/functions/actions";
import axios from "@/utils/axios";
const URL = "/examiner/prediction";
export const fetchPrediction = async (store, payload) => {
    store.commit(IS_LOADING, true);
    return await axios
        .get(`${URL}/${payload.studentEducationId}`)
        .then(({ data }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_SUCCESS, true);
        store.commit(SET_DATA_ITEM, data);
        return data;
    })
        .catch(({ response }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_ERROR, response.data);
    });
};
export const fetchValidity = async (store, payload) => {
    store.commit(IS_LOADING, true);
    return await axios
        .get(`${URL}/${payload.studentEducationId}/validity`)
        .then(({ data }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_SUCCESS, true);
        store.commit(SET_VALIDITY, data);
    })
        .catch(({ response }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_ERROR, response.data);
    });
};
export const fetchCanUseKiPilotTheory = async (store, payload) => {
    store.commit(IS_LOADING, true);
    return await axios
        .get(`/students/current/can-use-ki-pilot-theory`)
        .then(({ data }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_SUCCESS, true);
        store.commit(SET_CAN_USE_KI_PILOT_THEORY, data);
    })
        .catch(({ response }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_ERROR, response.data);
    });
};
// PILOT THEORY
export const findYoutubeLink = async (store) => {
    store.commit(IS_LOADING, true);
    return await axios
        .get(`/examiner/youtube-link`)
        .then(({ data }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_YOUTUBE_LINK, data);
    })
        .catch(({ response }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_ERROR, response.data);
    });
};
export const findPraxisOverview = async (store, payload) => {
    store.commit(IS_LOADING, true);
    return await axios
        .get(`/driving-lesson-routes/student-education/${payload.studentEducationId}/praxis-overview/self`)
        .then(({ data }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_PRAXIS_OVERVIEW, data);
    })
        .catch(({ response }) => {
        store.commit(IS_LOADING, false);
        store.commit(SET_ERROR, response.data);
    });
};
// KI-PILOT THEORY EXPLANATIONS
const fetchExplanation = async (store, path, mutation, studentEducationId) => {
    store.commit(SET_EXPLANATION_LOADING, true);
    store.commit(mutation, null);
    return await axios
        .get(`/examiner/${path}/${studentEducationId}`)
        .then(({ data }) => {
        store.commit(SET_EXPLANATION_LOADING, false);
        store.commit(mutation, data);
        return data;
    })
        .catch(({ response }) => {
        store.commit(SET_EXPLANATION_LOADING, false);
        store.commit(SET_ERROR, response?.data);
    });
};
export const findExplainVolume = async (store, payload) => {
    return fetchExplanation(store, "explain-volume", SET_EXPLAIN_VOLUME, payload.studentEducationId);
};
export const findExplainPreExamPerformance = async (store, payload) => {
    return fetchExplanation(store, "explain-pre-exam-performance", SET_EXPLAIN_PRE_EXAM_PERFORMANCE, payload.studentEducationId);
};
export const findExplainPerformance = async (store, payload) => {
    return fetchExplanation(store, "explain-performance", SET_EXPLAIN_PERFORMANCE, payload.studentEducationId);
};
export const findExplainGeneralOverview = async (store, payload) => {
    return fetchExplanation(store, "explain-general-overview", SET_EXPLAIN_GENERAL_OVERVIEW, payload.studentEducationId);
};
export const findExplainCategory = async (store, payload) => {
    return fetchExplanation(store, "explain-category", SET_EXPLAIN_CATEGORY, payload.studentEducationId);
};
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    getOne,
    resetSave,
    fetchPrediction,
    fetchValidity,
    fetchCanUseKiPilotTheory,
    findYoutubeLink,
    findPraxisOverview,
    findExplainVolume,
    findExplainPreExamPerformance,
    findExplainPerformance,
    findExplainGeneralOverview,
    findExplainCategory,
};
